import createIcon from '../../createIcon';

/**
 * @component @name NordicWalking
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNSAyMi43NUgxOFYxMy43NUgxOS41VjIyLjc1Wk04LjAzIDEzLjc1SDYuNUw0LjUgMjIuNzVINi4wM0w4LjAzIDEzLjc1Wk0xNCA1LjI1QzE1LjEgNS4yNSAxNiA0LjM1IDE2IDMuMjVDMTYgMi4xNSAxNS4xIDEuMjUgMTQgMS4yNUMxMi45IDEuMjUgMTIgMi4xNSAxMiAzLjI1QzEyIDQuMzUgMTIuOSA1LjI1IDE0IDUuMjVaTTEwLjMgOC42NUw3LjUgMjIuNzVIOS42TDExLjQgMTQuNzVMMTMuNSAxNi43NVYyMi43NUgxNS41VjE1LjI1TDEzLjQgMTMuMjVMMTQgMTAuMjVDMTUuMyAxMS43NSAxNy4zIDEyLjc1IDE5LjUgMTIuNzVWMTAuNzVDMTcuNiAxMC43NSAxNiA5Ljc1IDE1LjIgOC4zNUwxNC4yIDYuNzVDMTMuNjQgNS44NiAxMi41MiA1LjUgMTEuNTUgNS45MUw2LjUgOC4wNVYxMi43NUg4LjVWOS4zNUwxMC4zIDguNjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NordicWalking = createIcon('NordicWalking', [
  [
    'path',
    {
      d: 'M19.5 22.75H18V13.75H19.5V22.75ZM8.03 13.75H6.5L4.5 22.75H6.03L8.03 13.75ZM14 5.25C15.1 5.25 16 4.35 16 3.25C16 2.15 15.1 1.25 14 1.25C12.9 1.25 12 2.15 12 3.25C12 4.35 12.9 5.25 14 5.25ZM10.3 8.65L7.5 22.75H9.6L11.4 14.75L13.5 16.75V22.75H15.5V15.25L13.4 13.25L14 10.25C15.3 11.75 17.3 12.75 19.5 12.75V10.75C17.6 10.75 16 9.75 15.2 8.35L14.2 6.75C13.64 5.86 12.52 5.5 11.55 5.91L6.5 8.05V12.75H8.5V9.35L10.3 8.65Z',
      key: '135mg2',
    },
  ],
]);

export default NordicWalking;
